import React, { useEffect, useState } from 'react';

export default function JGSignalStrength({ bitrateKbps }) {
  const [level, setLevel] = useState(1);
  const [flash, setFlash] = useState(false);

  // Convert bitrate -> signal level (audio-aware)
  useEffect(() => {
    let newLevel = 1;

    const isAudioCall = bitrateKbps < 120; // fine to keep

    if (isAudioCall) {
      if (bitrateKbps >= 40) newLevel = 5;
      else if (bitrateKbps >= 28) newLevel = 4;
      else if (bitrateKbps >= 18) newLevel = 3;
      else if (bitrateKbps >= 10) newLevel = 2;
      else newLevel = 1;
    } else {
      if (bitrateKbps >= 1500) newLevel = 5;
      else if (bitrateKbps >= 1000) newLevel = 4;
      else if (bitrateKbps >= 350) newLevel = 3;
      else if (bitrateKbps >= 150) newLevel = 2;
      else newLevel = 1;
    }

    if (newLevel < level) {
      setFlash(true);
      setTimeout(() => setFlash(false), 450);
    }

    setLevel(newLevel);
  }, [bitrateKbps, level]);

  const qualityLabel = {
    5: 'Excellent',
    4: 'Good',
    3: 'Fair',
    2: 'Weak',
    1: 'Unstable',
  }[level];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div className={`jg-signal-bars ${flash ? 'jg-flash' : ''}`}>
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="jg-bar"
            style={{
              opacity: i <= level ? 1 : 0.28,
              height: `${i * 5 + (i <= level ? 22 : 10)}px`,
            }}
          />
        ))}
      </div>

      <span
        style={{
          color: '#b7dcff',
          fontSize: 12,
          letterSpacing: 0.6,
          fontWeight: 600,
          textShadow: '0 0 4px rgba(18,255,238,0.4)',
        }}
      >
        {qualityLabel}
      </span>

      <style>{`
        .jg-signal-bars {
          display: flex;
          align-items: flex-end;
          gap: 3px;
          transition: transform 0.25s ease;
        }

        .jg-bar {
          width: 6px;
          border-radius: 4px;
          background: linear-gradient(
            180deg,
            #11ffee 0%,
            #00b7ff 60%,
            #0095ff 100%
          );
          box-shadow: 0 0 8px rgba(17,255,238,0.55);
          transition:
            height 0.28s ease,
            opacity 0.28s ease;
        }

        .jg-flash {
          animation: jgLowQualityFlash 0.45s ease;
        }

        @keyframes jgLowQualityFlash {
          0% { transform: scale(1); }
          35% { transform: scale(1.09); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
}
